var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ob-dialog',{attrs:{"heading":_vm.$t('assets.new')},on:{"ok":function($event){return _vm.ok()},"cancel":function($event){return _vm.close()}}},[_c('asset-form-core',{attrs:{"asset":_vm.asset}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }